var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{staticClass:"mt-10",attrs:{"title":"Situação dos contratos de garantia"}},[_c('guarantee-type-chart',{attrs:{"values":_vm.guaranteeStats}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }